/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScheduleTypeDto { 
    scheduleType?: ScheduleTypeDto.ScheduleTypeEnum;
}
export namespace ScheduleTypeDto {
    export const ScheduleTypeEnum = {
        Gps: 'GPS',
        Vhf: 'VHF',
        Communication: 'COMMUNICATION',
        Proximity: 'PROXIMITY',
        ExternalSensorReceiver: 'EXTERNAL_SENSOR_RECEIVER',
        VirtualFence: 'VIRTUAL_FENCE',
        Camera: 'CAMERA',
        HighActivityGps: 'HIGH_ACTIVITY_GPS',
        SolexGps: 'SOLEX_GPS'
    } as const;
    export type ScheduleTypeEnum = typeof ScheduleTypeEnum[keyof typeof ScheduleTypeEnum];
}


